export function getApiBaseUrl() {
  const configuredUrl = process.env.REACT_APP_BACKEND_URL?.trim();
  const hostname = typeof window === "undefined" ? "localhost" : window.location.hostname;
  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";
  const baseUrl = configuredUrl || "https://edith-landing-page-cxar.onrender.com";

  return `${baseUrl.replace(/\/+$/, "")}/api`;
}
